import {
  ALL_MANAGE_FIELD_KEYS,
  MANAGE_FIELD_KEY,
} from '#/shared/lib/manage-fields'
import type { ManageFieldKey } from '#/shared/lib/manage-fields'

import type { OrderFormPayload } from '../ui/order-form'

type StripFn = (payload: OrderFormPayload) => void

const STRIPPERS: Partial<Record<ManageFieldKey, StripFn>> = {
  [MANAGE_FIELD_KEY.vehicleVin]: (p) => {
    p.vehicles.vehicles.forEach((v) => {
      v.vin = ''
    })
  },
  [MANAGE_FIELD_KEY.customerCompany]: (p) => {
    p.customer.company = ''
  },
  [MANAGE_FIELD_KEY.customerBillingEmail]: (p) => {
    p.customer.billingEmail = ''
  },
  [MANAGE_FIELD_KEY.customerCompanyPhone]: (p) => {
    p.customer.companyPhone = ''
  },
  [MANAGE_FIELD_KEY.customerAltPhone]: (p) => {
    p.customer.mobile = ''
  },
  [MANAGE_FIELD_KEY.customerAltEmail]: (p) => {
    p.customer.email2 = ''
  },
  [MANAGE_FIELD_KEY.customerNote]: (p) => {
    p.customer.note = ''
  },
  [MANAGE_FIELD_KEY.originBusinessName]: (p) => {
    p.location.origin.businessName = ''
  },
  [MANAGE_FIELD_KEY.originNote]: (p) => {
    p.location.origin.additionalNote = ''
  },
  [MANAGE_FIELD_KEY.destinationBusinessName]: (p) => {
    p.location.destination.businessName = ''
  },
  [MANAGE_FIELD_KEY.destinationNote]: (p) => {
    p.location.destination.additionalNote = ''
  },
  [MANAGE_FIELD_KEY.shipmentTags]: (p) => {
    p.shipment.tags = []
  },
  [MANAGE_FIELD_KEY.shipmentCustomerNote]: (p) => {
    p.shipment.customerNote = ''
  },
  [MANAGE_FIELD_KEY.paymentDefaultMethods]: (p) => {
    p.payment.paymentMethod = ''
    p.payment.paymentTerms = ''
    p.payment.balanceMethod = ''
    p.payment.balanceTime = ''
    p.payment.balanceTermBegins = ''
  },
}

export function stripHiddenFields(
  payload: OrderFormPayload,
  hidden: Partial<Record<ManageFieldKey, true>>,
): OrderFormPayload {
  const next: OrderFormPayload = structuredClone(payload)
  for (const key of ALL_MANAGE_FIELD_KEYS) {
    if (!hidden[key]) continue
    const fn = STRIPPERS[key]
    fn?.(next)
  }
  return next
}
